import { Injectable } from "@angular/core";
import { Subscription } from "rxjs";

@Injectable() // Instance per class instance
export class SubscriptionTracker {
  private subscriptions: Subscription[] = [];

  constructor() { }

  public add(subscription: Subscription): Subscription {
    if (subscription) {
      if (this.subscriptions) {
        // First remove any closed subscriptions
        this.removeAll(true);
        // Add our new subscription to the array
        this.subscriptions.push(subscription);
      }
      else {
        // Not defined, create new array with our new subscription in
        this.subscriptions = [subscription];
      }
    }
    return subscription;
  }

  public remove(subscription: Subscription) {
    if (subscription && this.subscriptions) {
      if (this.subscriptions) {
        // Unsubscribe if needed
        if (!subscription.closed) subscription.unsubscribe();
        // Look for the subscription in the array
        let index = this.subscriptions.indexOf(subscription);
        if (index !== -1) {
          // Subscription found
          // Remove from the array
          this.subscriptions.splice(index, 1);
        }
      }
    }
  }

  public removeAll(removeOnlyClosed: boolean = false) {
    if (this.subscriptions) {
      // Loop through all entries in reverse order
      for (let i = this.subscriptions.length - 1; i >= 0; --i) {
        // Find subscription
        let item: Subscription = this.subscriptions[i];
        let removeItem: boolean = true;
        if (!item?.closed) {
          // Subscription still active, what do we do with it?
          if (removeOnlyClosed) {
            // We're only removing already closed subscriptions, so mark it to be kept
            removeItem = false;
          }
          else {
            // We're removing all subscriptions, so unsubscribe
            item?.unsubscribe();
          }
        }
        // Remove item if needed
        if (removeItem) this.subscriptions.splice(i, 1);
      }
    }
  }

}
